import type { PartnerStatus } from "~/entity/Partners";

export const PARTNERS_STATUS_OPTIONS: PartnerStatus[] = [
  "Активный",
  "Архивный",
];
